import { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Mail, MessageCircle, Send } from "lucide-react";
import { toast } from "sonner";

const CHANNEL_LABEL = { email: "Email", whatsapp_link: "WhatsApp (opened)", whatsapp_auto: "WhatsApp (auto)" };

export const PaymentReminder = ({ patient, onSent }) => {
  const [cfg, setCfg] = useState({ whatsapp_auto: false });
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/reminders/config").then((r) => setCfg(r.data)); }, []);

  const send = async (channel) => {
    setBusy(channel);
    try {
      await api.post(`/patients/${patient._id}/remind`, { channel });
      toast.success(`Reminder sent by ${CHANNEL_LABEL[channel]}`);
      onSent();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not send reminder"); }
    setBusy("");
  };

  const openWhatsApp = async () => {
    const win = window.open("", "_blank");
    try {
      const { data } = await api.get(`/patients/${patient._id}/reminder`);
      if (!data.wa_link) { win?.close(); toast.error("Patient phone is missing or invalid — fix it in Modify"); return; }
      if (win) win.location.href = data.wa_link; else window.location.href = data.wa_link;
      await api.post(`/patients/${patient._id}/remind`, { channel: "whatsapp_link" });
      onSent();
    } catch (e) { win?.close(); toast.error(e?.response?.data?.detail || "Could not open WhatsApp"); }
  };

  const last = patient.last_reminder;
  return (
    <div className="mt-4 pt-3 border-t border-slate-200" data-testid="payment-reminder">
      <p className="text-[11px] uppercase font-semibold text-slate-400 mb-2">Send payment reminder</p>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" disabled={!patient.email || !!busy} onClick={() => send("email")} className="h-8" data-testid="remind-email-button" title={patient.email ? "" : "Add an email in Modify"}><Mail className="h-3.5 w-3.5 mr-1.5" />Email</Button>
        <Button size="sm" variant="outline" disabled={!patient.phone} onClick={openWhatsApp} className="h-8 border-emerald-300 text-emerald-700 hover:bg-emerald-50" data-testid="remind-whatsapp-button" title={patient.phone ? "" : "Add a phone in Modify"}><MessageCircle className="h-3.5 w-3.5 mr-1.5" />WhatsApp</Button>
        {cfg.whatsapp_auto && (
          <Button size="sm" disabled={!patient.phone || !!busy} onClick={() => send("whatsapp_auto")} className="h-8 bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="remind-whatsapp-auto-button"><Send className="h-3.5 w-3.5 mr-1.5" />Auto-send WhatsApp</Button>
        )}
      </div>
      {!patient.phone && !patient.email && <p className="text-[11px] text-slate-400 mt-2" data-testid="remind-no-contact">Add the patient's phone or email in Modify to send reminders.</p>}
      {last && <p className="text-[11px] text-slate-500 mt-2" data-testid="last-reminder">Last reminded {new Date(last.at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })} via {CHANNEL_LABEL[last.channel]}{last.by ? ` by ${last.by}` : ""}</p>}
    </div>
  );
};
